import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import { QueueKey } from 'flow/types/EntityKeys';
import { selectQueueDescription } from 'flow/selectors/queue-selectors';
import RadioButton from 'flow/components/ui-components/RadioButton';
import SettingSection from 'flow/components/Setting/SettingSection';
import useAppContext from 'flow/hooks/useAppContext';

export type MembersType = 'me' | 'queuemembers_all';

interface Props {
    context: string;
    onSelectMembersType: (type: MembersType) => void;
    membersTypeSelected: MembersType;
    queueKey: QueueKey;
}

const SelectMembersQueueCallTicket = ({
    context,
    onSelectMembersType,
    membersTypeSelected,
    queueKey,
}: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const queueName = useAppSelector((state) =>
        selectQueueDescription(state, queueKey),
    );

    const onSelect = (type: MembersType) => {
        onSelectMembersType(type);
        const segmentEvent =
            type === 'me'
                ? TICKET_STRINGS.CREATION_MEMBERS_CLICKED_SELF
                : TICKET_STRINGS.CREATION_MEMBERS_CLICKED_ALL_QUEUE_MEMBERS;
        dispatch(
            segmentTrack(segmentEvent, {
                component: context,
            }),
        );
    };

    return (
        <div className="flex flex-col">
            <SettingSection>
                {i18next.t('tickets.ticket.ticket_members')}
            </SettingSection>
            <RadioButton
                name={'queuemembers_all'}
                checked={membersTypeSelected === 'queuemembers_all'}
                onChange={() => onSelect('queuemembers_all')}
            >
                {i18next.t('tickets.create.members.all_queue_members', {
                    queueName: queueName,
                    interpolation: { escapeValue: false },
                })}
            </RadioButton>
            <RadioButton
                name={'queuemembers_all'}
                checked={membersTypeSelected === 'me'}
                onChange={() => onSelect('me')}
            >
                {i18next.t('tickets.create.members.me')}
            </RadioButton>
        </div>
    );
};

export default SelectMembersQueueCallTicket;
